<template>
  <UiAlertDialog :open="true">
    <UiAlertDialogContent
      class="border-ultra aspect-[9/6] w-full max-w-3xl p-0"
    >
      <PanelsLoginPanel />
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>
